const Button = {
	baseStyle: {
		focus: {
			boxShadow: 'none'
		}
	},
};

export const ButtonComponent = {
	components: {
		Button,
	},
};
